const state = {
  // Decides whether the banner is visible or not
  visible: false,
  type: '',
  title: '',
  message: '',
  icon: '',
  iconColor: 'primary',
  confirmBtnText: ''
};

const mutations = {
  setVisibility(stateIn, visibleIn) {
    stateIn.visible = visibleIn;
  },
  setType(stateIn, typeIn) {
    stateIn.type = typeIn;
  },
  setTitle(stateIn, titleIn) {
    stateIn.title = titleIn;
  },
  setMessage(stateIn, messageIn) {
    stateIn.message = messageIn;
  },
  setIcon(stateIn, iconIn) {
    stateIn.icon = iconIn;
  },
  setIconColor(stateIn, iconColorIn) {
    stateIn.iconColor = iconColorIn;
  },
  setConfirmBtnText(stateIn, confirmBtnTextIn) {
    stateIn.confirmBtnText = confirmBtnTextIn;
  }
};

const getters = {
  visible(stateIn) {
    return stateIn.visible;
  },
  type(stateIn) {
    return stateIn.type;
  },
  title(stateIn) {
    return stateIn.title;
  },
  message(stateIn) {
    return stateIn.message;
  },
  icon(stateIn) {
    return stateIn.icon;
  },
  iconColor(stateIn) {
    return stateIn.iconColor;
  },
  confirmBtnText(stateIn) {
    return stateIn.confirmBtnText;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};